import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  select: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    textOverflow: 'ellipsis',
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
  header: {
    justifyContent: 'space-around',
    paddingBottom: 20,
  },
  otaspHeader: {
    justifyContent: 'space-around',
    paddingTop: 20,
    paddingBottom: 20,
  },
  divider: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    width: '100%'
  }
}));

export default useStyles;